var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3505_21524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4247 20.8096C10.1044 20.8096 5.7991 17.9742 3.2009 15.2935C2.36988 14.4312 2.36988 13.1283 3.2009 12.266C5.82914 9.55721 10.2095 6.69843 14.5899 6.74998C18.9753 6.68905 23.3507 9.55252 25.9839 12.2613C26.815 13.1283 26.815 14.4265 25.9839 15.2888C23.3507 18.0023 18.9603 20.8845 14.5749 20.8049C14.5248 20.8049 14.4698 20.8049 14.4197 20.8049L14.4247 20.8096ZM14.4447 8.15594C10.595 8.15594 6.6952 10.7523 4.31227 13.208C4.00189 13.5314 4.00189 14.0235 4.31227 14.3515C6.72023 16.8307 10.6901 19.4645 14.5749 19.4036C18.4947 19.4833 22.4596 16.8354 24.8676 14.3515C25.1779 14.0282 25.1779 13.5361 24.8676 13.208C22.4846 10.757 18.5848 8.16062 14.7351 8.16062C14.69 8.16062 14.645 8.16062 14.5999 8.16062H14.5749C14.5298 8.16062 14.4848 8.16062 14.4397 8.16062L14.4447 8.15594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5899 17.9976C13.3884 17.9976 12.257 17.5571 11.406 16.7604C10.5549 15.9637 10.0894 14.9045 10.0894 13.7798C10.0894 11.4552 12.1118 9.56189 14.5949 9.56189C15.7964 9.56189 16.9278 10.0024 17.7788 10.7944C18.6299 11.5912 19.1004 12.6503 19.1004 13.7751C19.1004 14.9045 18.6299 15.9637 17.7788 16.7604C16.9278 17.5571 15.7964 17.9929 14.5949 17.9929L14.5899 17.9976ZM14.5899 10.9678C12.9329 10.9678 11.5862 12.2285 11.5862 13.7798C11.5862 14.5296 11.8966 15.2373 12.4673 15.7668C13.038 16.2964 13.7889 16.5917 14.5899 16.5917C15.3909 16.5917 16.1468 16.3011 16.7125 15.7668C17.2782 15.2373 17.5936 14.5296 17.5936 13.7798C17.5936 13.0252 17.2832 12.3223 16.7125 11.788C16.1418 11.2537 15.3909 10.9632 14.5899 10.9632V10.9678Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3505_21524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0346,
    height: 14.0596,
    fill: "white",
    transform: "translate(2.5752 6.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRead);
export default __webpack_public_path__ + "static/media/read.9512724f6224446dd8cc7934796ca07a.svg";
export { ForwardRef as ReactComponent };